// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"pagination_paginationWrapper__9K6F-","blackBox":"pagination_blackBox__CxE7i","pageNumber":"pagination_pageNumber__7abRc","active":"pagination_active__ayLUY"};